<section class="tw-flex tw-flex-wrap tw-gap-2">
  @if (campaign?.showCustomHighlight) {
    <span
      class="YellowTag p-text-tag tw-inline-block tw-rounded tw-bg-opacity-80 tw-px-2 tw-py-1 tw-uppercase !tw-text-white"
    >
      <img
        src="assets/img/icons/common/fluent_sparkle-28-filled.png"
        alt="Custom Highlight"
        width="15"
        height="13"
      />
      {{ campaign.customHighlightMessage }}
    </span>
  }
  @for (tag of tags?.slice(0, max); track tag) {
    <span class="tags-list__item p-text-tag">
      {{ tag.name }}
    </span>
  }
  @if (max && tags.length > max) {
    <span class="p-text-tag tw-italic !tw-tracking-normal"> +{{ tags.length - max }} more </span>
  }
  @if (partnershipBacked) {
    <span
      [ngClass]="PartnershipBacked[partnershipBacked]"
      class="p-text-tag tw-inline-block tw-rounded tw-bg-opacity-80 tw-px-2 tw-py-1 tw-uppercase !tw-text-white"
      >{{ 'campaign.' + PartnershipBacked[partnershipBacked] | translate }}
    </span>
  }
  @for (item of campaignImpacts; track item) {
    <span
      [ngClass]="Impact[item.impact]"
      class="p-text-tag tw-inline-block tw-rounded tw-bg-opacity-80 tw-px-2 tw-py-1 tw-uppercase"
      >{{ 'campaign.' + Impact[item.impact] | translate }}</span
    >
  }
</section>
